import React from 'react';
import ToolbarButton from './ToolbarButton';
import * as styles from './ToolbarSyntaxButton.module.scss';
import useAppSelector from '../../../../app/redux/useAppSelector';
import Select from '../../../../components/Select';
import { languageList, PlainLanguage } from '../../../code/Prism';

interface ToolbarSyntaxButtonProps {
  languageKey?: string | null;
  dropdownOpen: boolean;
  onDropdownOpenChange: (open: boolean) => void;
  onSelect: (key: string) => void;
}

const ToolbarSyntaxButton = ({
  languageKey = PlainLanguage.key,
  dropdownOpen,
  onDropdownOpenChange,
  onSelect,
}: ToolbarSyntaxButtonProps) => {
  const currentLanguage =
    languageKey && languageList.find(({ key }) => key === languageKey);

  const popularCodeLanguages = useAppSelector(
    (state) => state.ui.popularCodeLanguages,
  );

  const topPopularOptions = Object.entries(popularCodeLanguages)
    .toSorted(([, a], [, b]) => b - a)
    .slice(0, 5)
    .flatMap((item) => {
      const language = languageList.find(({ key }) => key === item[0]);
      return language ? [{ label: language.label, value: language.key }] : [];
    })
    .toSorted((a, b) => a.label.localeCompare(b.label));

  const allOptions = languageList.map(({ key, label }) => ({
    label,
    value: key,
  }));

  return (
    <ToolbarButton
      rightAlignPopOver
      renderPopOver={(onClose) => (
        <div className={styles.container}>
          <Select
            autoFocus
            menuIsOpen
            disableMenuPortal
            components={{
              DropdownIndicator: null,
            }}
            controlShouldRenderValue={false}
            hideSelectedOptions={false}
            isClearable={false}
            backspaceRemovesValue={false}
            value={languageKey}
            onChange={(key) => {
              onSelect(key);
              onClose();
            }}
            placeholder="Search for languages..."
            options={[
              { label: 'Popular', options: topPopularOptions },
              { label: 'All', options: allOptions },
            ]}
          />
        </div>
      )}
      popOverOpen={dropdownOpen}
      onPopOverOpenChange={onDropdownOpenChange}
    >
      {currentLanguage ? currentLanguage.label : PlainLanguage.label}
    </ToolbarButton>
  );
};

export default ToolbarSyntaxButton;
